/**
 * Mappe le payload login (déjà unwrapped) vers user + tokens.
 * Évite le crash `resp.user.firstName` quand l'enveloppe n'est pas aplatie.
 */
export type LoginAuthUser = {
  firstName: string;
  email: string;
  role: string;
};

export type ParsedLoginResult = {
  user: LoginAuthUser;
  accessToken: string;
  refreshToken: string | null;
};

export function parseLoginPayload(resp: {
  accessToken?: string | null;
  refreshToken?: string | null;
  user?: {
    firstName?: string | null;
    email?: string | null;
    role?: string | null;
    token?: string | null;
  } | null;
}): ParsedLoginResult {
  if (!resp.user || typeof resp.user !== "object") {
    throw new Error("Réponse de connexion invalide (utilisateur manquant)");
  }

  const accessToken = resp.accessToken || resp.user.token || null;
  if (!accessToken) {
    throw new Error("Réponse de connexion invalide (token manquant)");
  }

  if (!resp.user.email) {
    throw new Error("Réponse de connexion invalide (email manquant)");
  }

  return {
    user: {
      firstName: resp.user.firstName ?? "",
      email: resp.user.email,
      role: resp.user.role ?? "",
    },
    accessToken,
    refreshToken: resp.refreshToken || null,
  };
}
